import React, { useEffect, useState } from 'react';
import { RefreshCw, Loader2, Inbox } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLeads = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchLeads = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API}/leads`);
      if (!res.ok) throw new Error('Failed to load leads');
      const data = await res.json();
      setLeads(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  const formatDate = (iso) => {
    try {
      const d = new Date(iso);
      return d.toLocaleString('en-IN', {
        day: '2-digit', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
      });
    } catch {
      return iso;
    }
  };

  return (
    <div className="admin-leads" data-testid="admin-leads">
      <div className="admin-header">
        <div>
          <div className="admin-eyebrow">LUMEERO · ADMIN</div>
          <h1 className="admin-title">Leads</h1>
          <p className="admin-sub">{leads.length} {leads.length === 1 ? 'entry' : 'entries'}</p>
        </div>
        <button onClick={fetchLeads} className="admin-refresh" data-testid="admin-refresh">
          <RefreshCw size={16} />
          <span>Refresh</span>
        </button>
      </div>

      {loading && (
        <div className="admin-state">
          <Loader2 className="spin" size={20} />
          <span>Loading...</span>
        </div>
      )}

      {error && !loading && (
        <div className="admin-state admin-error">{error}</div>
      )}

      {!loading && !error && leads.length === 0 && (
        <div className="admin-empty">
          <Inbox size={32} strokeWidth={1.5} />
          <p>No leads yet.</p>
        </div>
      )}

      {!loading && !error && leads.length > 0 && (
        <div className="admin-table-wrap">
          <table className="admin-table" data-testid="admin-leads-table">
            <thead>
              <tr>
                <th>Received</th>
                <th>Name</th>
                <th>Email</th>
                <th>Brand</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((lead) => (
                <tr key={lead.id} data-testid={`lead-row-${lead.id}`}>
                  <td className="cell-mono">{formatDate(lead.created_at)}</td>
                  <td>{lead.name}</td>
                  <td><a href={`mailto:${lead.email}`} className="cell-link">{lead.email}</a></td>
                  <td>{lead.brand}</td>
                  <td className="cell-message">{lead.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminLeads;
